import { useCallback, useState } from "react";
import xml2js from 'xml2js';

const useFetchTransactionHistory = () => {
    const [transactionHistory, setTransactionHistory] = useState([]);
    const [historyLoading, setHistoryLoading] = useState(false);
    const [historyError, setHistoryError] = useState(null);

    const fetchTransactionHistory = useCallback(async (dateRangeType, startDate = null, endDate = null, messageFlowType = null, senderName = null) => {
        if (!process.env.REACT_APP_GET_EDI_TRANSACTIONS_HISTORY || !process.env.REACT_APP_APIKEY) {
            throw new Error("Required environment variables are missing");
        }
        const TRANSACTION_HISTORY_ENDPOINT = process.env.REACT_APP_GET_EDI_TRANSACTIONS_HISTORY;
        const APIKEY = process.env.REACT_APP_APIKEY;

        const logMessage = dateRangeType === "Custom"
            ? `Fetching transactions for dateRangeType: ${dateRangeType}, startDate: ${startDate?.toISOString()}, endDate: ${endDate?.toISOString()}`
            : `Fetching transactions for dateRangeType: ${dateRangeType}`;
        console.log(logMessage);

        // Format dates to YYYY-MM-DD
        const formatDate = (date) => date ? date.toISOString().split('T')[0] : '';

        const formattedStartDate = formatDate(startDate);
        const formattedEndDate = formatDate(endDate);

        let HISTORY_ENDPOINT =
            dateRangeType === "DAY" ? `${TRANSACTION_HISTORY_ENDPOINT}dateRange?DateRangeType=${dateRangeType}` :
                dateRangeType === "WEEK" ? `${TRANSACTION_HISTORY_ENDPOINT}dateRange?DateRangeType=${dateRangeType}` :
                    dateRangeType === "MONTH" ? `${TRANSACTION_HISTORY_ENDPOINT}dateRange?DateRangeType=${dateRangeType}` :
                        `${TRANSACTION_HISTORY_ENDPOINT}dateRange?EventStartDate=${formattedStartDate}&EventEndDate=${formattedEndDate}&DateRangeType=${dateRangeType}`;

        // Append MessageFlowType if provided
        if (messageFlowType) {
            HISTORY_ENDPOINT += `&MessageFlowType=${messageFlowType}`;

            // Append senderName if provided
            if (senderName) {
                HISTORY_ENDPOINT += `&SenderName=${senderName}`;
            }
        }

        setHistoryLoading(true);
        setHistoryError(null);

        try {
            console.log("Fetching URL: ", HISTORY_ENDPOINT);

            const response = await fetch(HISTORY_ENDPOINT, {
                headers: {
                    "x-api-key": APIKEY
                }
            });

            if (!response.ok) {
                throw new Error(`Network response was not ok: ${response.statusText}`);
            }

            const xmlData = await response.text();

            const parser = new xml2js.Parser({ explicitArray: false });
            const result = await parser.parseStringPromise(xmlData);

            // Ensure transactionList is an array
            let transactions = result?.transactionList?.transaction;

            // Normalize transactions to an array
            if (transactions) {
                if (!Array.isArray(transactions)) {
                    transactions = [transactions]; // Convert single object to array
                }
            } else {
                transactions = [];
            }

            console.log("Transformed JSON History Data:", transactions);

            // Set the parsed JSON directly to state
            setTransactionHistory(transactions);

        } catch (error) {
            console.error('Error fetching transaction history:', error);
            setHistoryError(error);
        } finally {
            setHistoryLoading(false);
        }
    }, []);

    return {
        transactionHistory,
        fetchTransactionHistory,
        historyLoading,
        historyError,
    };
};

export default useFetchTransactionHistory;
